import actions from './actions';
import { createReducer } from '../../../helpers/reducer';
import { keyBy } from '../../../helpers/core';

const initState = {
  editForm: null,
  loading: false,
  showPaylocityResidentModal: false,
  paylocityResidentTextValue: '',
  paylocityIsResident: true,
  paylocitySelectedIndex: null,
};

function validate(/* attr, value */) {
  const error = '';

  return error;
}

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const propsArray = Object.keys(data);

  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: data[prop],
      error: validate(prop, data[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    editForm,
  };
}

function onClearStore() {
  return { ...initState };
}

function onUpdateSuccess(state, { payload }) {
  const { data } = payload;
  const propsArray = Object.keys(data);

  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: data[prop],
      error: validate(prop, data[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    editForm,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  if (editForm[attr] && editForm[attr].value !== value) {
    return {
      ...state,
      editForm: {
        ...editForm,
        [attr]: {
          value,
          error: validate(attr, value),
          name: attr,
          touched: true,
        },
      },
    };
  }

  return state;
}

function onChangePaylocityResidentProperty(state, { payload }) {
  const { attr, value } = payload;

  if ([attr] in state && state[attr] !== value) {
    return {
      ...state,
      [attr]: value,
    };
  }

  return state;
}

function onSelectForEditPaylocityResident(state, { payload }) {
  const { isResident, index, text } = payload;

  return {
    ...state,
    paylocityResidentTextValue: text,
    paylocityIsResident: isResident,
    paylocitySelectedIndex: index,
    paylocitySelectedIsResident: isResident,
    showPaylocityResidentModal: true,
  };
}

function onCancel(state) {
  return {
    ...state,
    isEdit: false,
    editForm: null,
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

function onToggleModalPaylocityResident(state) {
  const newModalState = {
    showPaylocityResidentModal: !state.showPaylocityResidentModal,
  };

  if (state.showPaylocityResidentModal) {
    newModalState.paylocityResidentTextValue = '';
    newModalState.paylocityIsResident = true;
    newModalState.paylocitySelectedIndex = null;
  }

  return { ...state, ...newModalState };
}

export { validate, initState };
export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CANCEL]: onCancel,
  [actions.UPDATE_SUCCESS]: onUpdateSuccess,
  [actions.TOUCH]: onTouch,
  [actions.TOGGLE_MODAL_PAYLOCITY_RESIDENT]: onToggleModalPaylocityResident,
  [actions.CHANGE_PAYLOCITY_RESIDENT_PROPERTY]: onChangePaylocityResidentProperty,
  [actions.SELECT_FOR_EDIT_PAYLOCITY_RESIDENT]: onSelectForEditPaylocityResident,
});
